import { Flex, FormControl, Switch } from '@chakra-ui/react'
import { useFieldArray } from 'react-hook-form'
import { FormContentBlock } from './FormContentBlock'
import { getAddSessionFormSchema } from './getAddSessionFormSchema'
import { renderAddSessionForm } from './renderAddSessionForm'
import { ScheduleSessionConfig } from './ScheduleSessionConfig/ScheduleSessionConfig'
import { Button } from '../common/styled'
import { SessionTypeSwitch } from './customFields/SessionTypeSwitch'

export const getMessageHandlerClass = (data) => (data && Object.keys(data)[0]?.substr(1)) || ''

export const AddSessionFormContent = (props) => {
    const { form,
        editSessionState,
        advanced,
        onSubmit,
        onAdvancedChange,
        fixVersion,
        fixVersionHandlers,
        sessionMessageProviders,
        routerEnabled,
        sessionType,
        setSessionType,
        sessions
    } =
        props
    const {
        control,
        handleSubmit,
        setValue,
        getValues,
        register,
        formState: { errors }
    } = form

    const { fields, append, remove } = useFieldArray({
        control,
        name: 'socketConnectHostPort',
        keyName: 'id'
    })

    const editSession = editSessionState?.params
    const isActive = editSessionState?.isActive

    const schema = getAddSessionFormSchema(
        editSession,
        isActive,
        sessionType,
        advanced,
        fixVersion,
        fixVersionHandlers,
        sessionMessageProviders,
        getValues,
        sessions
    )

    const submitButtonDisabled = Object.keys(errors).length > 0

    return (
        <form onSubmit={handleSubmit(onSubmit)}>
            <FormControl>
                {routerEnabled && <FormContentBlock>
                    <SessionTypeSwitch
                        value={sessionType}
                        onChange={setSessionType}
                        isDisabled={editSession}
                    />
                </FormContentBlock>}
                {renderAddSessionForm({
                    schema,
                    submitButtonDisabled,
                    control,
                    handleSubmit,
                    setValue,
                    register,
                    errors,
                    fields,
                    append,
                    remove,
                    ...props
                })}
                {/*TODO: figure out how to include this in schema, conditional hooks are forbidden in react*/}
                {advanced && (
                    <FormContentBlock header="Session Schedule">
                        <ScheduleSessionConfig
                            interval={props.intervals}
                            handleSaveSchedule={props.handleSaveSchedule}
                            isDisabled={isActive}
                        />
                    </FormContentBlock>
                )}
                <Flex mt={6} justifyContent="space-between">
                    <Flex alignItems='center'>
                        <Switch
                            sx={{ fontSize: '20px', alignItems: 'center' }}
                            isChecked={advanced}
                            onChange={(e) => onAdvancedChange(e.target.checked)}
                        >
                            Advanced
                        </Switch>
                    </Flex>
                    {!isActive && <Button type="submit" disabled={submitButtonDisabled}>
                        Submit
                    </Button>}
                    <Flex sx={{ width: 130 }} />
                </Flex>
            </FormControl>
        </form>
    )
}
